export default {"src":"/_next/static/media/colearn_logo.ff15334a.svg","height":30,"width":120,"blurWidth":0,"blurHeight":0};